import * as React from "react";
import { useEffect } from "react";
import { useOidc } from "@axa-fr/react-oidc";
import { useNavigate } from "react-router-dom";
import DefaultProfile from "../../assets/Default-Profile.png";
import styles from "./HeaderProfile.module.scss";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Overlay } from "components/Overlay";
import { ProfileDropdown } from "./ProfileDropdown";
import { useCurrentUser } from "services/currentUserService";
import { getAppConfig } from "../../services/configService";

export const ProfileBox = ({ collapsed }) => {
  const [show, setShow] = React.useState(false);
  const [showMenu, setShowMenu] = React.useState(false);
  const anchor = React.useRef();

  const toogle = () => setShow((prev) => !prev);

  const { logout } = useOidc();
  const navigate = useNavigate();

  const { data: userdata } = useCurrentUser();

  const logoutApp = () => {
    const { authServerUrl } = getAppConfig();
    localStorage.removeItem(`oidc.server:${authServerUrl}/`);
    navigate("/");
    sessionStorage.clear();
    setShow(false);
    setShowMenu(false);
    logout("/");
  };

  useEffect(() => {
    const close = (e) => {
      if (e?.target?.alt === "user-avatar") return;
      if (e?.target?.role !== "button") setShow(false);
    };

    document.addEventListener("mousedown", close);
    return () => {
      document.removeEventListener("mousedown", close);
    };
  }, []);

  useEffect(() => {
    const close = (e) => {
      if (e?.target?.role === "menu") return;
      if (e?.target?.role !== "button") setShowMenu(false);
    };

    document.addEventListener("mousedown", close);
    return () => {
      document.removeEventListener("mousedown", close);
    };
  }, []);

  return (
    <>
      <div
        className="d-flex align-items-center m-3 ms-4 mt-2 me-3 "
        style={{ maxWidth: "100%" }}
      >
        {show && <Overlay />}
        {showMenu && <Overlay />}
        {collapsed ? (
          <div
            onClick={toogle}
            className="d-flex align-items-center justify-content-center gap-2 cursor-pointer"
          >
            <div className={`me-1 ${styles["image-container"]}`}>
              <img
                className="h-100 w-100"
                style={{ cursor: "pointer" }}
                src={
                  userdata?.imageInfo?.documentFile?.downloadURL
                    ? userdata?.imageInfo?.documentFile?.downloadURL
                    : DefaultProfile
                }
                alt={DefaultProfile}
                ref={anchor}
              />
            </div>
          </div>
        ) : (
          <div
            onClick={toogle}
            className="d-flex align-items-center
                justify-content-between cursor-pointer ps-1 mb-1 w-100"
            style={{ minWidth: 0 }}
          >
            <ImageContainer>
              <img
                className="h-100 w-100 me-1"
                style={{ cursor: "pointer" }}
                src={
                  userdata?.imageInfo?.documentFile?.downloadURL
                    ? userdata?.imageInfo?.documentFile?.downloadURL
                    : DefaultProfile
                }
                alt={DefaultProfile}
                ref={anchor}
              />
            </ImageContainer>

            <div
              className="ms-2  mt-2 me-1"
              style={{ flex: "1 1 auto", minWidth: 0, overflow: "hidden" }}
            >
              <div style={{ minWidth: 0 }}>
                <div
                  style={{ lineHeight: "10px" }}
                  className="text-start text-truncate"
                >
                  <span className={`mb-0 ${styles["user-name"]}`}>
                    {userdata?.displayname}
                  </span>
                </div>
                <div
                  className="text-start"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%",
                  }}
                >
                  <span className={`mb-0 ${styles["gray-text"]}`}>
                    {userdata?.emailAddress}
                  </span>
                </div>
              </div>
            </div>

            <div
              role={"menu"}
              className={`cursor-pointer p-1 m-1a ${styles["menu-hover"]}`}
              style={{ flexShrink: 0 }}
            >
              <BsThreeDotsVertical size={25} color="black" role="menu" />
            </div>
          </div>
        )}
      </div>

      {showMenu && <Overlay hideOverlay={() => setShowMenu(false)} />}

      <ProfileDropdown
        show={show}
        anchorEl={anchor.current}
        onClose={() => setShow(false)}
        settingsEnabled={!!userdata.isAdmin}
      />
    </>
  );
};

export const List = ({ imageSrc, name, onClick, border, icon }) => (
  <span className={styles["list-item"]} role="button" onClick={onClick}>
    <span
      role="button"
      className="flex align-items-center ms-4 pe-0 ps-4"
      style={{ padding: "15px 0px 15px 0px" }}
    >
      {icon ? (
        <span style={{ marginRight: "13px" }}>{icon}</span>
      ) : (
        <img src={imageSrc} alt="Image" style={{ marginRight: "15px" }} />
      )}
      <span role="button" className={`${styles.list}`}>
        {name}
      </span>
    </span>
    {border && <div className={`${styles["border-bottom"]}`}></div>}
  </span>
);

const ImageContainer = (props) => (
  <div className={`${styles["image-container"]} ${props.class}`}>
    {props.children}
  </div>
);
